import React, { useEffect, useState } from 'react';
import { FlyoutSecondMenu } from 'chameleon/ui-stack/ui/assessments/actions/FlyoutSecondMenu';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import { LoadingLabel } from '../../../pdf/DownloadButton/paperscorer';
import ScoringWorksheetAction from 'chameleon/legacy/src/utility/AssessmentActions/actions/ScoringWorksheetAction';
import { associatedResourcesQuery } from 'chameleon-src/queries';
import { toast } from 'chameleon/ui-stack/ui/toast';
import { transformAssociatedResourcesList } from 'chameleon/ui-stack/ui/assessments/util';
import { getSignedS3ResourceUrl } from 'chameleon-src/utility/signedUrl';
import {
  STUDENT_TEST_BOOK,
  SCORING_WORKSHEET,
  SCORING_GUIDE,
} from 'legacy/src/constants/assessmentResourceTypes';

const RelatedPdfsAction = ({
  isProcessing,
  resourceGroupActions,
  isMCQPPC,
  resources,
  handleResourceClick,
  assessmentId,
  educationPeriod,
  client,
}) => {
  const [pdfResources, setPdfResources] = useState([]);
  const [associatedResourcesObj, setAssociatedResourcesObj] = useState(
    transformAssociatedResourcesList(resources),
  );

  const fetchAssociatedResources = async () => {
    try {
      const response = await client.query({
        query: associatedResourcesQuery,
        variables: { assessmentId, educationPeriod },
      });
      return response.data.assessment.associatedResources;
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      toast(
        'An error occurred while getting the document. Please try again later.',
      );
    }
  };

  useEffect(async () => {
    if (resources.length === 0) {
      const pdfResources = await fetchAssociatedResources();
      const urlPromises = pdfResources.map((r) =>
        getSignedS3ResourceUrl(r.resourceUrl),
      );
      const results = await Promise.all(urlPromises);
      let mappedResources = pdfResources.map((r, index) => ({
        ...r,
        resourceUrl: results[index],
      }));
      setPdfResources(mappedResources);
      setAssociatedResourcesObj(transformAssociatedResourcesList(pdfResources));
    }
  }, [resources]);

  return (
    <FlyoutSecondMenu
      size="auto"
      isNarrow
      className="update-labels"
      position="right-end"
      trigger={(buttonProps, isOpen, reference) => (
        <AccessibilityWrapper>
          <SingleAction
            iconName="sheet_options"
            ref={reference}
            {...buttonProps}
            disabled={false}
          >
            Related PDFs
            <Icon id="chevron_right" className="ml-0.8 h-4 self-center" />
          </SingleAction>
        </AccessibilityWrapper>
      )}
    >
      <div role="menu">
        {isProcessing && (
          <div class="p-4">
            {' '}
            <LoadingLabel />{' '}
          </div>
        )}
        {!isProcessing && (
          <ul role="group" className="p-0 m-0 pt-1 pr-6">
            {resourceGroupActions.includes(STUDENT_TEST_BOOK) && (
              <li
                role="menuitem"
                className="list-none m-0 flex justify-between"
              >
                <AccessibilityWrapper>
                  <SingleAction
                    disabled={isMCQPPC}
                    role="button"
                    tabIndex="0"
                    onClick={() =>
                      handleResourceClick(
                        STUDENT_TEST_BOOK,
                        pdfResources.find(
                          (resource) =>
                            resource.resourceType === STUDENT_TEST_BOOK,
                        ),
                      )
                    }
                    className="text-left"
                    iconName="download_sheet"
                  >
                    <span className="item-text">Test Book</span>
                  </SingleAction>
                </AccessibilityWrapper>
              </li>
            )}
            {resourceGroupActions.includes(SCORING_GUIDE) && (
              <li
                role="menuitem"
                className="list-none m-0 flex justify-between"
              >
                <AccessibilityWrapper>
                  <SingleAction
                    disabled={false}
                    role="button"
                    tabIndex="0"
                    onClick={() =>
                      handleResourceClick(
                        SCORING_GUIDE,
                        pdfResources.find(
                          (resource) => resource.resourceType === SCORING_GUIDE,
                        ),
                      )
                    }
                    className="text-left"
                    iconName="scoring_guideline"
                    title="Download Answer Sheets"
                    ariaLabel="Download Answer Sheets"
                  >
                    <span className="item-text">Scoring Guide</span>
                  </SingleAction>
                </AccessibilityWrapper>
              </li>
            )}
            {resourceGroupActions.includes(SCORING_WORKSHEET) && (
              <li
                role="menuitem"
                className="list-none m-0 flex justify-between"
              >
                <AccessibilityWrapper>
                  <ScoringWorksheetAction
                    role="link"
                    associatedResources={associatedResourcesObj}
                    assessmentId={assessmentId}
                    educationPeriod={educationPeriod}
                    client={client}
                  />
                </AccessibilityWrapper>
              </li>
            )}
          </ul>
        )}
      </div>
    </FlyoutSecondMenu>
  );
};

export default RelatedPdfsAction;
